import type { SubscriptionApi } from "@/Modules/Models/Api/Subscription";
import type { Subscription } from "@/Modules/Models/Domain/Subscription";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateSubscriptionStatus } from "@/Services/TherapyApi/Subscriptions";

import useSubscriptionStore from "@/Modules/Subscription/Store";

import camelize from "@/Utils/Camelize";

const subscriptionApiToDomain = (subscriptionResponse: SubscriptionApi): Subscription => {
  return camelize<SubscriptionApi>(subscriptionResponse) as Subscription;
};

async function updateSubscriptionStatusAH(subscriptionUuid: string): Promise<void> {
  const subscriptionStore = useSubscriptionStore();

  try {
    subscriptionStore.isLoading = true;

    const subscriptionResponse = await updateSubscriptionStatus(subscriptionUuid);

    subscriptionStore.subscription = subscriptionApiToDomain(subscriptionResponse);
  } catch (error: unknown) {
    subscriptionStore.notification = {
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      code: "generic error",
    };
  } finally {
    subscriptionStore.isLoading = false;
  }
}

export default updateSubscriptionStatusAH;
